import { useMutation } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

type RemoveBrandCreatorPayload = {
  merchantId: string;
  creatorId: string;
};

export const useRemoveBrandCreator = () => {
  return useMutation({
    mutationFn: async ({ merchantId, creatorId }: RemoveBrandCreatorPayload) => {
      const res = await client.admin["brand-creators"][":merchantId"][":creatorId"].$delete({
        param: { merchantId, creatorId },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["admin", "brand-creators", variables.merchantId],
      });
    },
  });
};
